import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=067f76e4&scoped=true&"
import script from "./Reader.vue?vue&type=script&lang=js&"
export * from "./Reader.vue?vue&type=script&lang=js&"
import style0 from "./Reader.vue?vue&type=style&index=0&id=067f76e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f76e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067f76e4')) {
      api.createRecord('067f76e4', component.options)
    } else {
      api.reload('067f76e4', component.options)
    }
    module.hot.accept("./Reader.vue?vue&type=template&id=067f76e4&scoped=true&", function () {
      api.rerender('067f76e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/Reader.vue"
export default component.exports